import { Record, OrderedSet } from 'immutable'
import dateFns from 'date-fns'

export const OT_TYPES = {
  RICH_TEXT: 'RichText',
  JSON1: 'JSON1',
}

const DefaultRecord = Record(
  {
    id: '',
    createdAt: 0,
    updatedAt: 0,
    lastHistoryVersion: 0,
    lastActivityAt: 0,
    lastActivityBy: '',
    lastActivityType: null,
    archivedAt: null,
    archivedBy: null,
    activityAcknowledgement: null,
    activityCount: 0,
    title: '',
    organizationId: '',
    channelId: '',
    channel: null,
    createdBy: null,
    listPosition: 0,
    otType: OT_TYPES.RICH_TEXT,

    iconShape: null,
    iconColor: null,
    hasChildren: false,

    publicShareToken: false,
    publiclySharedAt: null,
    publiclySharedBy: null,
    madePubliclyEditableAt: null,
    madePubliclyEditableBy: null,
    shareLink: null,

    parentNote: null,

    history: OrderedSet(),
    activities: OrderedSet(),
    writerIds: OrderedSet(),
    commenterIds: OrderedSet(),
    mentionedIds: OrderedSet(),

    contentAsJSON: null,
    contentAsText: '',

    isLocked: false,
  },
  'note'
)

class NotesRecord extends DefaultRecord {
  getId() {
    return this.get('id')
  }

  getCreatedAt() {
    return this.get('createdAt')
  }

  getUpdatedAt() {
    return this.get('updatedAt')
  }

  getOrganizationId() {
    return this.get('organizationId')
  }

  getChannelId() {
    return this.get('channelId')
  }

  getTitle() {
    return this.get('title')
  }

  getCreationDate() {
    return dateFns.format(this.getCreatedAt(), 'DD/MM/YYYY HH:mm')
  }

  getUpdateDate() {
    return dateFns.format(this.getUpdatedAt(), 'DD/MM/YYYY HH:mm')
  }

  mergeFrowRaw(data) {
    return this.merge(data)
  }

  static createFromRaw(data) {
    const noteRecord = new NotesRecord({ id: data.id })
    return noteRecord.mergeFrowRaw(data)
  }
}

export const isArchived = note => !!note.archivedAt

export default NotesRecord

export function createFromRaw(rawNote) {
  return NotesRecord.createFromRaw(rawNote)
}
